<template>
  <div class="roomcreate">    
    <section class="body">      
      <chat-roomcreate-form @save-data="saveData" :isMobile="true" @cancel="tryClose"/>
    </section>  
  </div>
</template>

<script>
import { chatroomcreate } from "@/components/mixins/chat/chatroomcreate.js";
export default {    
    mixins:[chatroomcreate],
    data() {
        return {
            isMobile:true
        };
    },
    components:{
    
    }, 
    computed: {
        
    },
    methods: {
        tryClose(){
            this.$emit("cancel");
        }
    },
};
</script>

<style lang="scss" scoped>
.roomcreate{
    background:#fff;    
    display: flex;
    flex-direction: column;
    justify-content: space-between;   
    
}

</style>
